const initialState = {
    student:null,
    parent: null,
    studentUser:null,
    chartData:null,
    chartRules:{
        growthRate:[1.1,1.1,1.15,1.15,1.25,1.25,1.25,1.25],
        maxLevel:12,
        showScore:false,
        isTeacher:false
    },
    xLabel:"Weeks",
    yLabel:"Levels",
    appName:"",
    tabNum:1,
    firstLogin: false,
    apps: {
        bestScores: null,
        pictureNamingScores: [],
        kidSpeakScores: [],
        kidSignScores: [],
        wordSignSayScores: [],
        copyRightScores: [],
        wordMarkScores: []
    },
    appStates:{
        allowedApps:[],
        filteredApps:[],
        finishedApps:[]
    }
};

export default function(state = initialState, action) {
    switch (action.type) {
        case "UPDATE_STUDENT":
            return { ...state, student: action.student };
        case "UPDATE_PARENT":
            return { ...state, parent: action.parent };
        case "UPDATE_STUDENT_USER":
            return { ...state, studentUser: action.studentUser };
        case "UPDATE_TEACHER":
            return { ...state, teacher: action.teacher };
        case "UPDATE_FIRST_LOGIN":
            return { ...state, firstLogin: action.firstLogin };
        case "UPDATE_CHART_DATA":
            return { ...state, chartData: action.chartData, chartRules: action.chartRules, xLabel:action.xLabel, yLabel: action.yLabel };
        case "UPDATE_FUNCTION_UPDATE_NOTE":
            return { ...state, updateNote: action.updateNote };
        case "UPDATE_APPNAME":
            return { ...state, appName: action.appName };
        case "SELECT_CLASS":
            return { ...state, lastClass: action.lastClass };
        case "SELECT_STUDENT_TAB":
            return { ...state, studentTab: action.studentTab };
        case "SELECT_SCORELIST_TAB":
            return { ...state, studentScoreListTab: action.studentScoreListTab };
        case "LOGOUT":
            return {...state,...initialState};
        case "UPDATE_STUDENT_APPS_STATUS":
            return {...state, apps: action.apps};
        case "UPDATE_STUDENT_ACCOUNT_TAB":
            return {...state, tabNum: action.tabNum};
        case "UPDATE_STUDENT_APP_STATES":
            return {...state, appStates: action.appStates};
        default:
            return state;
    }
}
